// src/layouts/Pages/PageHeader/CardHeaderColumns/items/location.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { EnvironmentOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import appService from 'services/appService';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const locationItem = record => {
  const location = record?.address?.__city;
  const fullAddress = record?.address?.__fullAddress;

  const handleClick = () => {
    appService.handleCopyToClipboard(fullAddress);

    appService.notification({
      flag: 'success',
      icon: <EnvironmentOutlined />,
      title: 'location_copied',
      description: translateX('open_maps_question', { location }),
      noTranslateDescription: true,
      duration: 0,
      actions: [
        { text: 'no', type: 'default' },
        {
          text: 'yes',
          type: 'primary',
          onClick: () => window.open(`https://www.google.com/maps/place/${encodeURIComponent(fullAddress)}`, '_blank'),
        },
      ],
    });
  };

  return {
    key: 'location',
    icon: <EnvironmentOutlined />,
    label: location,
    tooltipText: translateX('localization'),
    tooltipPlacement: 'right',
    onClick: fullAddress ? handleClick : null,
  };
};

export default locationItem;
